import { Routes } from '@angular/router';

import { env } from '@amfam/environment';
import { Partners } from '@amfam/shared/utility/brand/lib/services/brand.enum';

import { forgerockAuthGuard } from '../core/auth/forgerock-auth.guard';
import { maintenanceGuard } from '../core/maintenance/maintenance.guard';
import { ErrorRoutes } from '../error/error.routes';
import { loginRedirectGuard } from './login.redirect.guard';

// Builds whose footer links route to in-app pages instead of amfam.com
const isInternalFooterBuild = () =>
  [Partners.LEMONADE, Partners.MSA].some(id => id === env.myAccountBuildGroupId);

export const LoginRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [maintenanceGuard],
    children: [
      ...ErrorRoutes,
      {
        path: 'login',
        loadComponent: () =>
          import('./login-base/login-base.component').then(m => m.LoginBaseComponent),
        canActivate: [loginRedirectGuard]
      },
      {
        path: 'login/invalid',
        loadComponent: () =>
          import('./login-base/login-base.component').then(m => m.LoginBaseComponent),
        data: { invalid: true }
      },
      {
        path: 'forgot-userid',
        loadComponent: () =>
          import('./forgot-userid/forgot-userid.component').then(m => m.ForgotUseridComponent),
        canActivate: [loginRedirectGuard]
      },
      {
        path: 'session-expired',
        loadComponent: () =>
          import('./session-expired/session-expired.component').then(
            m => m.SessionExpiredComponent
          ),
        canActivate: [loginRedirectGuard]
      },
      {
        path: 'company-information',
        loadComponent: () =>
          import('../shared/footer-links/company-information/company-information.component').then(
            m => m.CompanyInformationComponent
          )
      },
      {
        path: 'privacy-security-policy',
        loadComponent: () =>
          import('../shared/footer-links/privacy-security-policy/privacy-security-policy.component').then(
            m => m.PrivacySecurityPolicyComponent
          )
      },
      {
        path: 'legal-notice',
        canMatch: [() => env.myAccountBuildGroupId === Partners.AMFAM_EXCLUSIVE],
        loadComponent: () =>
          import('../shared/footer-links/legal-notice/legal-notice.component').then(
            m => m.LegalNoticeComponent
          )
      },
      {
        path: 'legal-notice',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/legal-notice-nonafi/legal-notice-nonafi.component').then(
            m => m.LegalNoticeNonAfiComponent
          )
      },
      {
        path: 'underwriting-companies',
        canMatch: [isInternalFooterBuild],
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/underwriting-companies/underwriting-companies.component').then(
            m => m.UnderwritingCompaniesComponent
          )
      },
      {
        path: 'terms-and-conditions',
        canMatch: [isInternalFooterBuild],
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/terms-and-conditions/terms-and-conditions.component').then(
            m => m.TermsAndConditionsComponent
          )
      },
      {
        path: 'terms-and-conditions/terms-use-text',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/terms-use-text/terms-use-text.component').then(
            m => m.TermsUseTextComponent
          )
      },
      {
        path: 'terms-and-conditions/billingaccountpolicyterms-use-text',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/billingaccountpolicyterms-use-text/billingaccountpolicyterms-use-text.component').then(
            m => m.BillingAccountPolicyTextingTermsComponent
          )
      },
      {
        path: 'terms-and-conditions/salesterms-use-text',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/salesterms-use-text/salesterms-use-text.component').then(
            m => m.SalesTermsUseTextComponent
          )
      },
      {
        path: 'privacy-security',
        canMatch: [isInternalFooterBuild],
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/privacy-security/privacy-security.component').then(
            m => m.PrivacySecurityComponent
          )
      },
      {
        path: 'cpa',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/cpa/cpa.component').then(
            m => m.CpaComponent
          )
      },
      {
        path: 'cookie-policy',
        loadComponent: () =>
          import('@amfam/shared/ui/footer/lib/components/cookie-policy/cookie-policy.component').then(
            m => m.CookiePolicyComponent
          )
      },
      {
        path: 'validate-email/:token',
        loadComponent: () =>
          import('../profile/validate-email-token/validate-email-token.component').then(
            m => m.ValidateEmailTokenComponent
          ),
        canActivate: [forgerockAuthGuard]
      },
      {
        path: 'email-validation',
        loadComponent: () =>
          import('./email-validation/email-validation.component').then(
            m => m.EmailValidationComponent
          ),
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./email-validation/email-validation-login/email-validation-login.component').then(
                m => m.EmailValidationLoginComponent
              )
          },
          {
            path: 'verify-phone',
            loadComponent: () =>
              import('./email-validation/email-validation-verify-phone/email-validation-verify-phone.component').then(
                m => m.EmailValidationVerifyPhoneComponent
              )
          }
        ]
      }
    ]
  }
];
